import React from "react";
import "./ColumnLayout.css";

/**
 * ColumnLayout (uniwersalny)
 * Układ na dowolną liczbę kolumn (dzieci), z kontrolą odstępu przez prop gap.
 */
export default function ColumnLayout({ children, gap = "lg", className = "" }) {
    const gapClass =
        gap === "sm"
            ? "columnLayout--gap-sm"
            : gap === "md"
                ? "columnLayout--gap-md"
                : "columnLayout--gap-lg";

    return <div className={`columnLayout ${gapClass} ${className}`.trim()}>{children}</div>;
}